import React, {useEffect, useState, useRef} from 'react'
import './home.css';
import { Link } from 'react-router-dom'
import rightArrow from './../assets/rightArrow.png'
import stopButton from './../assets/stop.png';
import playButton from './../assets/play.png';
import arrowRightRest from './../assets/arrowRightRest.png'
import restaurantListHe from './../restaurants/restaurantsListHe'
import restaurantList from './../restaurants/restaurantsList'
import {Helmet} from "react-helmet";
import ChangeLang from '../changeLang/changeLang';

function Home() {
	const position = useRef(0)
	const intervalSlider = useRef(null)
	// 0 means imageSlider going left, 1 means going right
	const UpOrDown = useRef(0)
	const mouseDown = useRef(false)
	const dragEvents = useRef({firstX: null, marginLeft: null, movement: null})
	
	// Contact twice to replicate the restaurants list for the 2nd slider, for cloning for infinite loop on edges
	const [restaurants, ] = useState(restaurantList.concat(restaurantList).concat(restaurantList));
	const [restaurantsHe, ] = useState(restaurantListHe.concat(restaurantListHe).concat(restaurantListHe));
	const positionRes = useRef((window.innerWidth>1050) ? -0.96*window.innerWidth : -2.88*window.innerWidth); 
	let [isPhone, setIsPhone] = useState(false)

	useEffect(() => {
		RunAutoSlider();
		isPhone = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
		setIsPhone(isPhone);

		// Target when contents is on screen, and then fade in animation
		let images = document.getElementsByClassName('imageLoads');
		const observerPics = new IntersectionObserver((entries) => {
			entries.forEach(entry => {
				if (entry.intersectionRatio > 0) {
					entry.target.src = entry.target.dataset.src;
				}
			})
		},{
			rootMargin: '1000px'
		})
		for (let image of images) {
			observerPics.observe(image);
		}
		
		return () => {
			clearInterval(intervalSlider.current);
			observerPics.disconnect();
		}
	}, [intervalSlider])

	let RunAutoSlider = () => {
		const imageSlider = document.getElementById('imageSlider');

		intervalSlider.current = setInterval(() => {
			let marginLeft = parseInt(getComputedStyle(imageSlider).marginLeft);
			if (UpOrDown.current === 0) {
				nextArrow();
				if (marginLeft ===  -1*(document.getElementById('imageSlider').children.length-1)*window.innerWidth) UpOrDown.current=1;
			}
			if (UpOrDown.current === 1) {
				previousArrow();		
				if (marginLeft === 0) UpOrDown.current=0;
			}

		}, 7000);
	}
	
    let previousArrow = () => {	
		let list = document.getElementById('imageSlider');
		
		// shift left
		position.current += window.innerWidth;
		// can't move to the left too much, end of images
		position.current = Math.min(position.current, 0)
		
		if (!isPhone) {
			const prevArrowElem = list.parentNode.nextSibling;
			const nextArrowElem = list.parentNode.nextSibling.nextSibling;
			// For changing cursor of the next/prev button according to the state of the slider
			if (position.current  ===  0) {
				prevArrowElem.style.cursor = 'not-allowed';
			} else {
				nextArrowElem.style.cursor = 'pointer';
			}
		}
		
		list.style.marginLeft = position.current + 'px';
    };

   let nextArrow = () => {
		let list = document.getElementById('imageSlider');

		// shift right
		position.current -= window.innerWidth
		// can only shift the ribbbon for (total ribbon length - visible count) images
		position.current = Math.max(position.current, -window.innerWidth * (list.children.length - 1));

		if (!isPhone) {
			const prevArrowElem = list.parentNode.nextSibling;
			const nextArrowElem = list.parentNode.nextSibling.nextSibling;
			// For changing cursor of the next/prev button according to the state of the slider
			if (position.current  ===  -window.innerWidth * (list.children.length - 1)) {
				nextArrowElem.style.cursor = 'not-allowed';
			} else {
				prevArrowElem.style.cursor = 'pointer';
			}
		}
		
		list.style.marginLeft = position.current + 'px';
	};
	
	// Called when onClick'ed on  play/stop button to stop the interval
	let playStopFunction = () => {
		const playStopButton = document.getElementById('playStopButton');
		// If clicked on this while it was playing, so changing the button to Play and stopping the interval
		if (playStopButton.dataset.status === "playing") {
			playStopButton.src = playButton;
			playStopButton.dataset.status = "stopped";
			clearInterval(intervalSlider.current);
		} else { 
			playStopButton.src = stopButton;
			playStopButton.dataset.status = "playing";
			RunAutoSlider();
		}
	}

	let startDrag = (e) => {
		if (e.target.id==="playStopButton") return;

		let targ;
		isPhone ? e.type == 'touchstart' && (targ = e.touches[0].clientX) : targ = e.clientX;

		document.getElementById("carousel").style.cursor = "grabbing";
		dragEvents.current.firstX = targ; // Setting the initial X value of the grab, then in mouseMove event substracting it( X - afterMoveX  = dragEvents.current.movement)
		
		mouseDown.current = true; // Only cause MouseEvent when mouseDown
	}

	let endDrag = (e) => {
		if (e.target.id==="playStopButton") return;
		document.getElementById("carousel").style.cursor = "grab";
		mouseDown.current = false; // stop Mousemove event by changing this to false
		const list = document.getElementById('imageSlider');

		// If the movement drag of the mouse is less than 0.6 of the screenWidth, then don't move the slider. (For mobile phones 1/3 movement is required)
		// Each moment/move is window.innerWidth
		let maxDragValue;
		isPhone ? maxDragValue = Math.abs(dragEvents.current.movement)>window.innerWidth/3 : maxDragValue = Math.abs(dragEvents.current.movement)>window.innerWidth/6;

		if (maxDragValue) {
			// if going Right
			if (dragEvents.current.movement<0) {
				let change = Math.ceil(dragEvents.current.marginLeft*1/window.innerWidth)*window.innerWidth - window.innerWidth;
				// If it is at the end of the slider,  then stick it to the end
				if (change <= -window.innerWidth * (list.children.length - 1)) {
					list.style.marginLeft = -window.innerWidth * (list.children.length - 1) + 'px';
					if (!isPhone) list.parentNode.nextSibling.nextSibling.style.cursor = 'not-allowed'; // Applying style of not allowed to the Next Arrow Button
				} else { // Put it where needed
					list.style.marginLeft = change + 'px';
					if (!isPhone) list.parentNode.nextSibling.style.cursor = 'pointer';		
				}	

			} else { // if going left. 
				// If it is the start of the slider, then stick to the beginning(0)
				if (dragEvents.current.marginLeft-dragEvents.current.movement+window.innerWidth>=0) {
					list.style.marginLeft = 0 + 'px';
					if (!isPhone) list.parentNode.nextSibling.style.cursor = 'not-allowed';
				} else {
					list.style.marginLeft = Math.round((dragEvents.current.marginLeft-dragEvents.current.movement+window.innerWidth)/window.innerWidth)*window.innerWidth + 'px';
					if (!isPhone) list.parentNode.nextSibling.nextSibling.style.cursor = 'pointer';
				}
			}
		} else { // Just fix in case it wasn't swiped too "far"
			list.style.marginLeft = dragEvents.current.marginLeft - dragEvents.current.movement + 'px';
		}
	}

	let dragMove = (e) => {
		if (!mouseDown.current) return false;
		let targ;
		isPhone ? e.type == 'touchmove' && (targ = e.touches[0].clientX) : targ = e.clientX;
		const imageSlider = document.getElementById('imageSlider');
		let marginLeft = parseInt(getComputedStyle(imageSlider).marginLeft);
		document.getElementById('playStopButton').dataset.status = "playing";
		playStopFunction();

		marginLeft += targ-dragEvents.current.firstX;
		dragEvents.current.movement = targ-dragEvents.current.firstX;

		imageSlider.style.marginLeft = marginLeft + 'px';
		dragEvents.current.marginLeft = marginLeft;
	}
	
	let changeSection2 = (e) => {
		const dots = document.getElementById('dots');
		// If it is the same number as the last one chose, so don't change - just quit the function ( dataset.chose = last one chosen )
		if (dots.dataset.chose === e.target.dataset.id) return;
		// Removing active from the ULList of Section2 by fading out with class active
		dots.nextSibling.children[dots.dataset.chose].classList.remove('active');
		dots.children[dots.dataset.chose].classList.remove('active');

		dots.dataset.chose = e.target.dataset.id;
		dots.nextSibling.children[e.target.dataset.id].classList.add('active');

		dots.children[e.target.dataset.id].classList.add('active');
	}
	
	let nextArrowR = () => {
		let list = document.getElementById('imageSliderRestaurants');
		if (window.innerWidth>1050) {
			positionRes.current -= window.innerWidth*0.1601; // Because every LI is 16vw
			positionRes.current = Math.max(positionRes.current, -window.innerWidth*0.1601 * (list.children.length - 6));
			// If it is the end of this series, so send back to -96vw
			if (Math.max(positionRes.current, -window.innerWidth*0.1601 * (list.children.length - 6))  ===  -window.innerWidth*0.1601 * (list.children.length - 6)) {
				list.style.transition = 'unset';
				list.style.marginLeft = -0.96*window.innerWidth + 'px';
				setTimeout(() => {
					list.style.transition = 'margin-left 250ms';
					positionRes.current = -0.96*window.innerWidth;
					positionRes.current -= window.innerWidth*0.1601;
					list.style.marginLeft = positionRes.current + 'px';
				}, 15);		
			} else {
				list.style.marginLeft = positionRes.current + 'px';
			}
		} else {
			positionRes.current -= 2*window.innerWidth*0.4801; // Because every LI is 48vw now
			positionRes.current = Math.max(positionRes.current, -window.innerWidth*0.4801*(6+6+2));

			if (Math.max(positionRes.current, -window.innerWidth*0.4801*(6+6+2))  ===  -window.innerWidth*0.4801*(6+6+2)) {
				list.style.transition = 'unset';
				list.style.marginLeft = -2.88*window.innerWidth + 'px';
				setTimeout(() => {
					list.style.transition = 'margin-left 1s';
					positionRes.current = -2.88*window.innerWidth;
					positionRes.current -= 2*window.innerWidth*0.4801;
					list.style.marginLeft = positionRes.current + 'px';
				}, 15);		
			} else {
				list.style.marginLeft = positionRes.current + 'px';
			}
		}
	}
	
	let prevArrowR = () => {
		let list = document.getElementById('imageSliderRestaurants');
		if (window.innerWidth>1050) {
			positionRes.current += window.innerWidth*0.159;
			positionRes.current = Math.min(positionRes.current, 0);

			if (Math.min(positionRes.current, 0)  ===  0) {
				list.style.transition = 'unset';
				list.style.marginLeft = -0.96*window.innerWidth + 'px';
				setTimeout(() => {
					list.style.transition = 'margin-left 250ms';
					positionRes.current = -0.96*window.innerWidth;
					positionRes.current += window.innerWidth*0.159;
					list.style.marginLeft = positionRes.current + 'px';
				}, 15);
			} else {
				list.style.marginLeft = positionRes.current + 'px';
			}
		} else {
			positionRes.current += 2*window.innerWidth*0.4801;
			positionRes.current = Math.min(positionRes.current, 0.5);
			if (Math.min(positionRes.current, 0.5)  === 0.5) {
				list.style.transition = 'unset';
				list.style.marginLeft = -2.88*window.innerWidth + 'px';
				setTimeout(() => {
					list.style.transition = 'margin-left 1s';
					positionRes.current = -2.88*window.innerWidth;
					positionRes.current += 2*window.innerWidth*0.4801;
					list.style.marginLeft = positionRes.current + 'px';
				}, 15);
			} else {
				list.style.marginLeft = positionRes.current + 'px';
			}
		}
	}

	let cityBackground = () => {
		// Randomize color
		return { backgroundColor: "hsl(" + 360 * Math.random() + ',' +
		(25 + 70 * Math.random()) + '%,' + 
		(65 + 10 * Math.random()) + '%)'	}
	}

// If it is an English page, so render it in english
if (window.location.href.includes('/en')) {
	return (
		<div id="home">
			<Helmet>
				<html lang="en" />
				<title>© Itay Shiff - Restaurant Homepage</title>
				<meta 
				name="description" 
				content="© Itay Shiff - Restaurant Homepage | All in one solution - eCommerce, CMS, CRM, Live Track Orders, Optimizied SEO, Designed/Customized/Dynamic Website." />
				<link rel="canonical" href="https://itays-restaurant.web.app/en" />
			</Helmet>

			<ChangeLang/>

			<div id="carousel">
				<div className="gallery" onMouseDown={startDrag} onMouseMove={dragMove} onMouseUp={endDrag} onTouchStart={startDrag} onTouchMove={dragMove} onTouchEnd={endDrag}>
					<ul id="imageSlider" onMouseDown={() => false}>
						<li>
							<div className="imgWrapperShadow"></div>
							
							<div className="contentCarousel">
							<span>Hamburger</span>
							<div style={{fontSize: '100px', color: 'rgb(100,149,237)', fontWeight: 'bold'}}>ASADO</div>
							<hr/>
							<Link to="/en/menu" onClick={() => window.scrollTo(0,0)}><button>Watch Menu!</button></Link>
							</div>

							<img src="/assets/home/firstSlider/hamburger_asado.jpg" draggable="false" alt="hamburger asado"/>
						</li>

							<li><div className="imgWrapperShadow"></div>

							<div className="contentCarousel">
							<span>Salmon</span>
							<div style={{fontSize: '100px', color: 'rgb(100,149,237)', fontWeight: 'bold'}}>FILLET</div>
							<hr/>
							<button>Watch Menu!</button>
							</div>

							<img src="/assets/home/firstSlider/file_salmon_botnim.jpg" draggable="false" alt="salmon"/>
						</li>

						<li>
							<div className="imgWrapperShadow"></div>

							<div className="contentCarousel">
							<span>Crispy</span>
							<div style={{fontSize: '100px', color: 'rgb(100,149,237)', fontWeight: 'bold'}}>CHICKEN</div>
							<hr/>
							<button>Watch Menu!</button>
							</div>

							<img src='/assets/home/firstSlider/crispy_chicken_deal.jpg' draggable="false" alt="crispy chicken"/>
						</li>
						
				    	<li>
							<div className="imgWrapperShadow"></div>

							<div className="contentCarousel">
							<span>Pullet</span>
							<div style={{fontSize: '100px', color: 'rgb(100,149,237)', fontWeight: 'bold'}}>STEAK</div>
							<hr/>
							<button>Watch Menu!</button>
							</div>
							
							<img src="/assets/home/firstSlider/steak_pargit.jpg" draggable="false" alt="pullet"/>
						</li>
			    	</ul>
					<img id="playStopButton" src={stopButton} onClick={playStopFunction} data-status="playing" style={{cursor: 'pointer'}} alt="play stop button"/>
				</div>
				
				{!isPhone &&
				<React.Fragment>
					<img src={rightArrow} className="arrow prev" alt="left arrow" style={{cursor: 'not-allowed'}} onClick={previousArrow}/>
					<img src={rightArrow} className="arrow next" alt="right arrow" onClick={nextArrow}/>
				</React.Fragment>
				}
				
			</div>

			<div id="section1">
				<div id="leftSide">
					<div id="section1Content">					
						<div>Enjoy the best of both worlds
						<img src="/assets/home/section1/gridTopRight.png" style={{width: '50px', height: '50px', position: 'absolute', left: '0', top: '-60px', cursor: 'pointer'}} alt="follow on facebook"/>
						</div>
						<h3>Itay's Restaurant makes the best food in the city !</h3>
						<p>We make a "rise" to the best dishes in the world, presenting a menu of all worlds: Israeli, Italian, American, Far East, and Mexican in one restaurant.<br/></p>
						<p>You will no longer find a restaurant that offers such a wide variety of dishes tailored to the taste of the Israeli, everyone finds exactly what he likes here!</p>
						<Link to="/en/about" onClick={() => window.scrollTo(0,0)}><button>Read More</button></Link>
					</div>
				</div>

				<div id="rightSide">
					<div id="gridSection1">
						<Link to="/en/menu" onClick={() => window.scrollTo(0,0)}>
						<div className="inGridSection1">
							<img src="/assets/home/section1/gridTopLeft.jpg" alt="deal burger"/>
							<p>Have you heard about our deal burger???</p>
						</div>
						</Link>

						<div className="inGridSection1" id="facebookGridSection1">
						<img src="/assets/home/section1/gridTopRight.png" style={{width: '50px', height: '50px', position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%, -50%)'}} alt="follow on facebook"/>
							<p style={{textShadow: 'none'}}>FOLLOW US<br/>ON FACEBOOK!</p>
						</div>
						
						<Link to="/en/contact" onClick={() => window.scrollTo(0,0)}>
						<div className="inGridSection1">
							<img src="/assets/home/section1/gridBottomLeft.jpg" alt="work with us"/>
							<p>Work with us!</p>
						</div>
						</Link>

						<div className="inGridSection1">
							<a href="#restaurants"><div style={{width: '100%', height: '100%', position: 'absolute', borderRadius: '15px', boxShadow: 'inset 0px -30px 50px 10px black'}}></div> 
							<img src="/assets/home/section1/gridBottomRight.jpg" alt="our restaurants"/>
							<p>Our Restaurants</p></a>
						</div>
						
					</div>
				</div>
				
			</div>
			
			<div id="section2">
				<div id="leftSideSection2">
					<div id="dots" data-chose="0">
						<span data-id="0" className="active" onClick={changeSection2}></span>
						<span data-id="1" onClick={changeSection2}></span>
						<span data-id="2" onClick={changeSection2}></span>
						<span data-id="3" onClick={changeSection2}></span>
						<span data-id="4" onClick={changeSection2}></span>
					</div>

					<ul>
						<li className="active">
						<img className="imageLoads" data-src={"/assets/home/section2/carnivore.jpg"} alt="carnivore"/>
						<div><span>Carnivore</span>
						Have you tasted our Antricot?</div>
						</li>

						<li>
						<img className="imageLoads" data-src={"/assets/home/section2/middleEast.jpg"} alt="middle east food"/>
						<div><span>Middle East</span>
						The middle east is here</div>
						</li>

						<li>
						<img className="imageLoads" data-src={"/assets/home/section2/ravioli.jpg"} alt="ravioli"/>
						<div><span>Ravioli anyone?</span>
						Alfredo, Napolitana, Rosa or pesto cream</div>
						</li>
						
						<li>
						<img className="imageLoads" data-src={"/assets/home/section2/bread.jpg"} alt="bread"/>
						<div><span>Pastry</span>
						Cheese filled pastry</div>
						</li>

						<li>
						<img className="imageLoads" data-src={"/assets/home/section2/morning.jpg"} alt="variety of breakfast salads"/>
						<div><span>Good morning!</span>
						A variety of breakfasts only here</div>
						</li>

					</ul>
					
				</div>
				<div id="rightSideSection2">
					<img src="/assets/home/section2/earth.png" alt="earth"/>
					<div style={{width: '90%', margin: '0 auto'}}> {/* For Centering the content */}
						<div style={{color: 'black', fontWeight: 'bold'}}>Menu of all worlds</div>
						<div style={{color: 'red', paddingBottom: '25px', fontWeight: 'bold'}}>The most varied cuisine</div>
						<p>Going out to a restaurant? Do you want meat and your spouse wants pasta? The kids in general want pizza.<br/>
						No need to fight, just come to Itay's Restaurant and order whatever comes your way.
						And if you come already, you should come hungry 😊</p>
						<Link to="/en/menu" onClick={() => window.scrollTo(0,0)}><button>Go Menu</button></Link>
					</div>
				</div>
			</div>

			<div id="restaurants">
				<img src="/assets/home/ITAYSORANGE.png" id="restaurantLogo" alt="restaurant logo - itay's restaurant"/>
				<div id="ourRestaurants">				
					<img src={arrowRightRest} onClick={prevArrowR} draggable="false" style={{left: '30px', transform: 'rotateY(180deg) translateY(-4vw)'}} alt="previous arrow"/>
					Our Restaurants
					<img src={arrowRightRest} onClick={nextArrowR} draggable="false" style={{right: '30px'}} alt="next arrow"/>	
				</div>


				<div id="carouselRestaurants"> 
					<div className="galleryRestaurants">
						<ul id="imageSliderRestaurants">
							
							{restaurants.map((val, index) => 
								<li key={index}>
									<img className="imageLoads" data-src={"/assets/restaurants/" + val.name} draggable="false" alt={val.title + ' restaurant'}/>
									<div className="contentCarousel">
										<div className="cityName" style={cityBackground()}>{val.title}</div>
										<div className="forResponsiveRest">
											<img src="/assets/restaurants/map.png" style={{top: '4.2vw'}} alt="location"/>
											<div className="address" dangerouslySetInnerHTML={{__html: val.address}}></div>
											<div className="phone"><img src="/assets/restaurants/phone.png" alt="phone"/>{val.phoneNumber}</div>
										</div>
									</div>
								</li>
							)}

						</ul>
					</div>
					
				</div>

			</div>

			<footer>
				<Link to="/en/technical" onClick={() => window.scrollTo(0,0)}>Click here to see the technical side of this website!</Link>
				<div>Contact email address: &nbsp; <a href="mailto:etay2468@gmail.com"><u>etay2468@gmail.com</u></a></div>
				<span>Ⓒ All rights reserved. Made with love by <strong>Itay Shiff  😊</strong></span>
				<div><b>All in one solution</b><div style={{lineHeight: '30px'}}>eCommerce, CMS, CRM, Live Track Orders, Optimizied SEO, Designed/Customized/Dynamic Website</div></div>
			</footer>

			
		</div>		
	)
}


// Else render it in hebrew
	return (
		<div id="home" className="hebrew">
			<Helmet>
				<title>דף הבית | המסעדה של איתי שיף ©</title>
				<meta 
				name="description" 
				content="© המסעדה של איתי שיף | הכל בפתרון אחד - eCommerce, מערכת ניהול תוכן, ניהול קשרי לקוחות, משלוחים במעקב לייב, SEO ממוטב, אתר דינמי ומעוצב אישית." />
				<link rel="canonical" href="https://itays-restaurant.web.app/" />
			</Helmet>

			<ChangeLang/>

			<div id="carousel">
				<div className="gallery" onMouseDown={startDrag} onMouseMove={dragMove} onMouseUp={endDrag} onTouchStart={startDrag} onTouchMove={dragMove} onTouchEnd={endDrag}>
					<ul id="imageSlider" onMouseDown={() => false}>
						<li>
							<div className="imgWrapperShadow"></div>
							
							<div className="contentCarousel">
							<span>המבורגר</span>
							<div style={{fontSize: '100px', color: 'rgb(100,149,237)', fontWeight: 'bold'}}>אסאדו</div>
							<hr/>
							<Link to="/menu" onClick={() => window.scrollTo(0,0)}><button>צפה בתפריט!</button></Link>
							</div>

							<img src="/assets/home/firstSlider/hamburger_asado.jpg" draggable="false" alt="hamburger asado"/>
						</li>

							<li><div className="imgWrapperShadow"></div>

							<div className="contentCarousel">
							<span>סלמון</span>
							<div style={{fontSize: '100px', color: 'rgb(100,149,237)', fontWeight: 'bold'}}>פילה</div>
							<hr/>
							<button>צפה בתפריט!</button>
							</div>

							<img src="/assets/home/firstSlider/file_salmon_botnim.jpg" draggable="false" alt="salmon"/>
						</li>

						<li>
							<div className="imgWrapperShadow"></div>

							<div className="contentCarousel">
							<span>קריספי</span>
							<div style={{fontSize: '100px', color: 'rgb(100,149,237)', fontWeight: 'bold'}}>צ'יקן</div>
							<hr/>
							<button>צפה בתפריט!</button>
							</div>

							<img src='/assets/home/firstSlider/crispy_chicken_deal.jpg' draggable="false" alt="crispy chicken"/>
						</li>
						
				    	<li>
							<div className="imgWrapperShadow"></div>

							<div className="contentCarousel">
							<span>סטייק</span>
							<div style={{fontSize: '100px', color: 'rgb(100,149,237)', fontWeight: 'bold'}}>פרגית</div>
							<hr/>
							<button>צפה בתפריט!</button>
							</div>
							
							<img src="/assets/home/firstSlider/steak_pargit.jpg" draggable="false" alt="pullet"/>
						</li>
			    	</ul>
					<img id="playStopButton" src={stopButton} onClick={playStopFunction} data-status="playing" style={{cursor: 'pointer'}} alt="play stop button"/>
				</div>
				
				{!isPhone &&
				<React.Fragment>
					<img src={rightArrow} className="arrow prev" alt="left arrow" style={{cursor: 'not-allowed'}} onClick={previousArrow}/>
					<img src={rightArrow} className="arrow next" alt="right arrow" onClick={nextArrow}/>
				</React.Fragment>
				}
				
			</div>

			<div id="section1">
				<div id="leftSide">
					<div id="section1Content">					
						<div>להנות מכל העולמות ביחד
						<img src="/assets/home/section1/gridTopRight.png" style={{width: '50px', height: '50px', position: 'absolute', left: '0', top: '-60px', cursor: 'pointer'}} alt="follow on facebook"/>
						</div>
						<h3>המסעדה של איתי מכינה את האוכל הטוב ביותר בעיר!</h3>
						<p>אנו עושים "עלייה" למנות הטובות בעולם, ובכך מציגים תפריט מכל העולמות: הישראלי, האיטלקי, האמריקאי, המזרח הרחוק, והמקסיקני במסעדה אחת.<br/></p>
						<p>לא תמצאו עוד מסעדה שמציעה מגוון כה רחב של מאכלים המותאמים בדיוק לטעמו של הישראלי, כל אחד מוצא כאן בדיוק את מה שהוא אוהב!</p>
						<Link to="/about" onClick={() => window.scrollTo(0,0)}><button>קרא עוד עלינו</button></Link>
					</div>
				</div>

				<div id="rightSide">
					<div id="gridSection1">
						<Link to="/menu" onClick={() => window.scrollTo(0,0)}>
						<div className="inGridSection1">
							<img src="/assets/home/section1/gridTopLeft.jpg" alt="deal burger"/>
							<p>שמעת כבר על הדילבורגר שלנו<span className="numChars">???</span></p>
						</div>
						</Link>

						<div className="inGridSection1" id="facebookGridSection1">
						<img src="/assets/home/section1/gridTopRight.png" style={{width: '50px', height: '50px', position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%, -50%)'}} alt="follow on facebook"/>
							<p style={{textShadow: 'none'}}>עקבו אחרינו<br/>בפייסבוק!</p>
						</div>

						<Link to="/contact" onClick={() => window.scrollTo(0,0)}>
						<div className="inGridSection1">
							<img src="/assets/home/section1/gridBottomLeft.jpg" alt="work with us"/>
							<p>בואו לעבוד איתנו !</p>
						</div>
						</Link>

						<div className="inGridSection1">
							<a href="#restaurants"><div style={{width: '100%', height: '100%', position: 'absolute', borderRadius: '15px', boxShadow: 'inset 0px -30px 50px 10px black'}}></div> 
							<img src="/assets/home/section1/gridBottomRight.jpg" alt="our restaurants"/>
							<p>המסעדות שלנו</p></a>
						</div>
						
					</div>
				</div>
				
			</div>
			
			<div id="section2">
				<div id="leftSideSection2">
					<div id="dots" data-chose="0">
						<span data-id="0" className="active" onClick={changeSection2}></span>
						<span data-id="1" onClick={changeSection2}></span>
						<span data-id="2" onClick={changeSection2}></span>
						<span data-id="3" onClick={changeSection2}></span>
						<span data-id="4" onClick={changeSection2}></span>
					</div>

					<ul>
						<li className="active">
						<img className="imageLoads" data-src={"/assets/home/section2/carnivore.jpg"} alt="carnivore"/>
						<div><span>קרניבור</span>
						טעמת כבר את האנטריקוט שלנו <div className="numChars">?</div></div>
						</li>

						<li>
						<img className="imageLoads" data-src={"/assets/home/section2/middleEast.jpg"} alt="middle east food"/>
						<div><span>אוכל ים תיכוני</span>
						המזרח התיכון נמצא כאן</div>
						</li>

						<li>
						<img className="imageLoads" data-src={"/assets/home/section2/ravioli.jpg"} alt="ravioli"/>
						<div><span>רביולי מישהו?</span>
						אלפרדו, נפוליטנה, רוזה או שמנת פסטו</div>
						</li>
						
						<li>
						<img className="imageLoads" data-src={"/assets/home/section2/bread.jpg"} alt="bread"/>
						<div><span>מאפה</span>
						מאפה במילוי גבינה</div>
						</li>

						<li>
						<img className="imageLoads" data-src={"/assets/home/section2/morning.jpg"} alt="variety of breakfast salads"/>
						<div><span>בוקר טוב <div className="numChars">!</div></span>
						מגוון רב של ארוחות בוקר רק כאן</div>
						</li>

					</ul>
					
				</div>
				<div id="rightSideSection2">
					<img src="/assets/home/section2/earth.png" alt="earth"/>
					<div style={{width: '90%', margin: '0 auto'}}> {/* For Centering the content */}
						<div style={{color: 'black', fontWeight: 'bold'}}>תפריט מכל העולמות</div>
						<div style={{color: 'red', paddingBottom: '25px', fontWeight: 'bold'}}>המטבח המגוון ביותר</div>
						<p>יוצאים למסעדה <span className="numChars">?</span> בא לך בשר והבן/בת זוג רוצה פסטה <span className="numChars">?</span> הילדים בכלל רוצים פיצה.<br/>
							לא צריך לריב, פשוט תבואו למסעדה של איתי ותזמינו מה שבא לכם.
							ואם אתם כבר באים, תבואו רעבים😊</p>
						<Link to="/menu" onClick={() => window.scrollTo(0,0)}><button>צפה בתפריט</button></Link>
					</div>
				</div>
			</div>

			<div id="restaurants">
				<img src="/assets/home/ITAYSORANGE.png" id="restaurantLogo" alt="restaurant logo - itay's restaurant"/>
				<div id="ourRestaurants">				
					<img src={arrowRightRest} onClick={prevArrowR} draggable="false" style={{left: '30px', transform: 'rotateY(180deg) translateY(-4vw)'}} alt="previous arrow"/>
					המסעדות שלנו
					<img src={arrowRightRest} onClick={nextArrowR} draggable="false" style={{right: '30px'}} alt="next arrow"/>	
				</div>


				<div id="carouselRestaurants"> 
					<div className="galleryRestaurants">
						<ul id="imageSliderRestaurants">
							
							{restaurantsHe.map((val, index) => 
								<li key={index}>
									<img className="imageLoads" data-src={"/assets/restaurants/" + val.name} draggable="false" alt={val.title + ' restaurant'}/>
									<div className="contentCarousel">
										<div className="cityName" style={cityBackground()}>{val.title}</div>
										<div className="forResponsiveRest">
											<img src="/assets/restaurants/map.png" style={{top: '4.2vw'}} alt="location"/>
											<div className="address" dangerouslySetInnerHTML={{__html: val.address}}></div>
											<div className="phone"><img src="/assets/restaurants/phone.png" alt="phone"/><span className="numChars">{val.phoneNumber}</span></div>
										</div>
									</div>
								</li>
							)}

						</ul>
					</div>
					
				</div>

			</div>

			<footer>
				<Link to="/technical" onClick={() => window.scrollTo(0,0)}>לחץ כאן כדי לראות את הצד הטכני של האתר!</Link>

				<div>צור קשר באימייל: &nbsp; <a href="mailto:etay2468@gmail.com" className="numChars"><u>etay2468@gmail.com</u></a></div>
				<span>Ⓒ כל הזכויות שמורות, נוצר על ידי <strong>איתי שיף  😊</strong></span>
				
				<div>
				<b>הכל בפתרון אחד</b>
					<div style={{lineHeight: '30px'}}>
						<span className="numChars">,e-Commerce</span> מערכת ניהול תוכן, ניהול קשרי לקוחות, משלוחים במעקב לייב, <span className="numChars">SEO</span> ממוטב, אתר דינמי ומעוצב אישית 
					</div>
				</div>
			</footer>

			
		</div>
	)
}

export default Home